import React from 'react'
import { Input, Select } from 'antd'
import { SearchOutlined } from '@ant-design/icons'

const { Option } = Select

const BedFilters = ({ searchText, setSearchText, wardFilter, setWardFilter, statusFilter, setStatusFilter, wards }) => {
  return (
    <div style={{ marginBottom: '16px', display: 'flex', flexWrap: 'wrap', gap: '16px', alignItems: 'center' }}>
      <Input
        placeholder='Search by patient name, bed ID or room'
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
        style={{ width: 250 }}
        prefix={<SearchOutlined />}
        allowClear
      />

      <Select placeholder='Ward' style={{ width: 180 }} value={wardFilter} onChange={(value) => setWardFilter(value)}>
        <Option value='all'>All Wards</Option>
        {wards.map((ward) => (
          <Option key={ward} value={ward}>
            {ward}
          </Option>
        ))}
      </Select>

      <Select
        placeholder='Status'
        style={{ width: 150 }}
        value={statusFilter}
        onChange={(value) => setStatusFilter(value)}
      >
        <Option value='all'>All Statuses</Option>
        <Option value='Available'>Available</Option>
        <Option value='Occupied'>Occupied</Option>
        <Option value='Cleaning'>Cleaning</Option>
      </Select>
    </div>
  )
}

export default BedFilters
